<template>
    <div>
        <base-table
            hide-default-footer
            v-bind="$attrs"
            v-on="$listeners"
            :headers="processedHeaders"
            :items="processedItems"
            :options="options"
            @click:row="onClickRowItem">
            <template v-slot:[`item.price`]="{ item }">
                <span>
                    {{ $util.getCurrencyFormat(item.price) }}
                </span>
            </template>

            <template v-slot:[`item.total`]="{ item }">
                <span>
                    {{ $util.getCurrencyFormat(item.total) }}
                </span>
            </template>

            <template v-slot:[`item.status`]="{ item }">
                <button-status-field
                    disableClick
                    hideIcon
                    :status="item.status"/>
            </template>
        </base-table>
    </div>
</template>

<script>
import BaseTable from '@/components/tables/BaseTable'
import { TableMixinFactory } from '@/mixins/TableMixin'
import ButtonStatusField from '@/components/fields/ButtonStatusField'

export default {
    name: 'ProductTable',

    components: {
        BaseTable,
        ButtonStatusField
    },

    mixins: [TableMixinFactory()],

    props: {
        items: {
            type: Array,
            default: () => []
        },

        options: {
            type: Object,
            default: () => ({})
        }
    },

    data () {
        return {
            headers: [
                {
                    text: this.$t('ticketAndAddOns.productTable.header.ticketId'),
                    value: 'TicketNumber',
                    sortable: false
                },
                {
                    text: this.$t('ticketAndAddOns.productTable.header.productId'),
                    value: 'id',
                    sortable: false
                },
                {
                    text: this.$t('ticketAndAddOns.productTable.header.productName'),
                    value: 'ProductName',
                    sortable: false
                },
                {
                    text: this.$t('ticketAndAddOns.productTable.header.description'),
                    value: 'description',
                    sortable: false
                },
                {
                    text: this.$t('ticketAndAddOns.productTable.header.productType'),
                    value: 'productType',
                    sortable: false
                },
                {
                    text: this.$t('ticketAndAddOns.productTable.header.price'),
                    value: 'price',
                    align: 'right',
                    sortable: false
                },
                {
                    text: this.$t('ticketAndAddOns.productTable.header.amount'),
                    value: 'amount',
                    sortable: false
                },
                {
                    text: this.$t('ticketAndAddOns.productTable.header.total'),
                    value: 'total',
                    align: 'right',
                    sortable: false
                },
                {
                    text: this.$t('ticketAndAddOns.productTable.header.status'),
                    value: 'status',
                    width: '140px',
                    align: 'center',
                    sortable: false
                }
            ]
        }
    },

    methods: {
        onClickRowItem (item) {
            this.$emit('viewDetails', item)
        }
    }
}
</script>

<style lang="scss" scoped></style>
